module.exports = __webpack_public_path__ + "assets/edit-pen.ab6c688e.svg";